<div class="checkbox-select" #checkboxSelect>

  <input aria-label="checkbox"  type="text" class="select-input" readonly name="inputValue"
         [value]="inputValue" (click)="toggleOptionsSection($event)"
         [ngClass]="{'active': isOptionsSectionVisible}"
         *ngIf="options.length > 0"/>

  <input aria-label=""  type="text" class="select-input" readonly name="inputValue"
         value="No items found" disabled
         *ngIf="options.length === 0"/>

  <div class="select-container box-shadow" [@slideToggle]
       *ngIf="isOptionsSectionVisible">
    <label class="question-label checkbox select-option"
           *ngFor="let option of options"
           [ngClass]="{'selected': isOptionSelected(option)}"
           (click)="onOptionSelected(option)" [innerHTML]="option.text">
    </label>
  </div>

</div>
